import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params, RouterLink } from '@angular/router';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AccountService} from "../core/auth/account.service";
import {ToastrService} from "ngx-toastr";
import {IOrder, Order} from "../../shared/model/order.model";
import {filter, map} from "rxjs/operators";
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-checkout-redirect',
    templateUrl: './checkout-redirect.component.html',
    styleUrls: ['./checkout-redirect.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, MatIcon, MatCardContent, MatButton, RouterLink, DecimalPipe]
})
export class CheckoutRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private toastr = inject(ToastrService);
  private accountService = inject(AccountService);


  encryptedData: Params;
  error = false;
  isLoading = true;
  typeRetour: string;
  order: Order;
  apiUrl = environment.apiUrl;

  constructor() {
    this.route.params.subscribe( (params) => {
        this.encryptedData = params;
      });
  }

  ngOnInit(): void {
    this.typeRetour = String(this.encryptedData.typeRetour);
    this.order = this.getOrder(String(this.encryptedData.ref));
  }

  private getOrder(ref: string): Order {
    const ord = new Order();
    this.http.get<IOrder>(this.apiUrl + '/checkout/get-order/'+ref, {observe: 'response'})
      .pipe(
        filter((res: HttpResponse<IOrder>) => res.ok),
        map((res: HttpResponse<IOrder>) => res.body)
      )
      .subscribe((response: IOrder) => {
        ord.paymentReference = response.paymentReference;
        ord.statut = response.statut;
        ord.amountPaid = response.amountPaid;
        ord.paymentDate = response.paymentDate;
        ord.listRefInternes = response.listRefInternes;

        localStorage.removeItem('ieo_cb_reference');
        localStorage.removeItem('ieo_cb_amount');

        if ((this.order.statut !== 'payé' && this.typeRetour==='ok') || (this.order.statut !=='annulé' && this.typeRetour==='err')) {
          this.error = true;
        } else {
          if (this.order.statut === 'payé' && this.typeRetour==='ok') {
            localStorage.setItem('ieo_cb_reference', ord.paymentReference);
            localStorage.setItem('ieo_cb_amount', ord.amountPaid);
          }
        }
        this.isLoading = false;
      }, (error: string) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.error = true;
        this.isLoading = false;
        return null;
      });
    return ord;
  }

  public sendMail(): void {
    if (localStorage.getItem('ieo_cb_reference') != null && localStorage.getItem('ieo_cb_amount') != null ) {
      this.accountService.identity().then((authenticated) => {
        if (authenticated) {
          const body = {reference: localStorage.getItem('ieo_cb_reference'), amount: localStorage.getItem('ieo_cb_amount')};
          this.http.post(this.apiUrl + '/checkout/send-recap-mail', body, {observe: 'response', responseType: 'text'})
            .subscribe(() => {
              this.showSuccess('Un email avec le récapitulatif de votre paiement vient de vous être envoyé');
              localStorage.removeItem('ieo_cb_reference');
              localStorage.removeItem('ieo_cb_amount');
            }, () => {
              this.showError('Impossible d\'envoyer le mail récapitulatif de votre paiement');
              localStorage.removeItem('ieo_cb_reference');
              localStorage.removeItem('ieo_cb_amount');
            });
        } else {
          if (confirm('Vous allez être redirigé vers le formulaire d\'inscription sur le site MonCompte In Extenso, afin de créer le compte sur lequel l\'email sera envoyé')) {
            window.open('/login', '_blank');
          } else {
            this.showError('L\'envoi de l\'email récapitulatif a été annulé');
          }
        }
      });
    } else {
      this.showError('Impossible d\'envoyer le mail récapitulatif de votre paiement');
    }
  }

  public isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  private showError(error: string) {
    this.toastr.error(error, 'Erreur', {
      timeOut: 3000
    });
  }

  private showSuccess(message: string) {
    this.toastr.success(message, 'OK', {
      timeOut: 3000
    });
  }
}
